// tslint:disable
export enum TCSSource {
    /**
     * @description Unknown
     */
    Unknown = 0,
    /**
     * @description Janssen CarePath One Patient Portal
     */
    Patient = 5,
    /**
     * @description Janssen CarePath One Provider Portal
     */
    Provider = 6,
    /**
     * @description Janssen CarePath One Hub Portal
     */
    Hub = 7,
    /**
     * @description Janssen CarePath One Express Portal
     */
    Express = 8,
    /**
     * @description Opus Migration
     */
    OpusMigration = 10,
}
(TCSSource as any)['UNKNOWN'] = 0;
(TCSSource as any)['PATIENT'] = 5;
(TCSSource as any)['PROVIDER'] = 6;
(TCSSource as any)['HUB'] = 7;
(TCSSource as any)['EXPRESS'] = 8;
(TCSSource as any)['OPUSMIGRATION'] = 10;
